import { ErrorService } from './error/error.service';
import { NgModule } from "@angular/core";

import { AuthenticationService } from './authentication/authentication.service';
import { AuthenticationHttpService } from "./authentication/authentication-http.service";
import { AuthenticationStorage } from "./authentication/authentication-storage.service";
import { KeystoneAuthStorage, KeystoneHttpModule} from "../../keystone-http";
import { UserService } from '../user/user.service';
import { IonicStorageModule } from '@ionic/storage';

@NgModule({
  imports: [
    IonicStorageModule.forRoot({
      name: 'urmet_storage',
      driverOrder: ['localstorage', 'sqlite']
    }),
    KeystoneHttpModule.forRoot(),
  ],
  providers: [
    //DEVICE SERVICES
    //AUTHENTICATION SERVICES
    AuthenticationService,
    AuthenticationStorage,
    AuthenticationHttpService,
    {provide: KeystoneAuthStorage, useExisting: AuthenticationStorage},

    ErrorService,
    UserService
  ]
})
export class CoreModule {};



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts